import { useContext, useEffect, useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
import { Input, Button, Form, Table, Empty,Popover } from "antd";
import { useAgregarExperienciaProfesionalJurado } from "../../../hooks/useAgregarExperienciaprofesionalJurado";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ModalEditarExperienciasProfesionales } from "./ModalEditarExperienciasProfesionales";
import { ModalEliminarExperienciasPorfesionales } from "./ModalEliminarExperienciaProfesionales";
import { ModalVisualizarAviso } from "../AgregarExperienciaProfesional/ModalVisualizarAviso"
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import { openNotification } from "../../../utils/Notifactions";
import { TemplateContext } from "../../../utils/template_context";
import DocumentInput from "../../../utils/DocumentInput";
import DateInput from "../../../utils/DateInput";
import { useNavigate } from "react-router-dom";
import { handleSimpleFieldsChange } from "../../../utils/tablaConvocatoriaHelper";

export const AgregarExperienciaProfesional = () => {
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();
  const {
    experiencia,
    setExperiencia,
    experiencias,
    setExperiencias,
    modaleditar,
    setModaleditar,
    modaleliminar,
    setModaleliminar,
    indexExperiencia,
    setIndexExperiencia,
    fileInputRef,
    agregarFila,
    limpiarCampos,
    guardarCamposModal,
    guardarArchivo,
    eliminarFila,
    nombreConvocatoria,
    setNombreConvocatoria,
    guardarExperienciaJurado,
    modalVisualizar,
    setModalVisualizar,
    cargarExperienciasProfesionales,
    guardarExperienciaJuradoProfesional,
  } = useAgregarExperienciaProfesionalJurado();

  const [totalTiempo, setTotalTiempo] = useState<{ anios: number; meses: number }>({ anios: 0, meses: 0 });

  const calcularDiferenciaAniosMeses = (inicioStr?: string, finStr?: string) => {
    if (!inicioStr || !finStr) return { anios: 0, meses: 0 };
    const [yi, mi, di] = inicioStr.split("-").map((v: string) => parseInt(v, 10));
    const [yf, mf, df] = finStr.split("-").map((v: string) => parseInt(v, 10));
    if ([yi, mi, di, yf, mf, df].some((v) => Number.isNaN(v))) return { anios: 0, meses: 0 };
    const inicio = new Date(yi, (mi || 1) - 1, di || 1);
    const fin = new Date(yf, (mf || 1) - 1, df || 1);
    if (fin < inicio) return { anios: 0, meses: 0 };
    let totalMeses = (fin.getFullYear() - inicio.getFullYear()) * 12 + (fin.getMonth() - inicio.getMonth());
    if (fin.getDate() < inicio.getDate()) totalMeses -= 1;
    const anios = Math.floor(totalMeses / 12);
    const meses = totalMeses % 12;
    return { anios, meses };
  };

  useEffect(() => {
    if (!Array.isArray(experiencias)) return;
    let totalMeses = 0;
    experiencias.forEach((exp: any) => {
      const { anios, meses } = calcularDiferenciaAniosMeses(exp?.fecha_inicio, exp?.fecha_terminacion);
      totalMeses += anios * 12 + meses;
    });
    setTotalTiempo({ anios: Math.floor(totalMeses / 12), meses: totalMeses % 12 });
  }, [experiencias]);

  useEffect(() => {
    cargarExperienciasProfesionales();
    getConvocatoriaPersistente();
  }, []);

  const navigate = useNavigate();

  const context = useContext(TemplateContext);
  // columnas tabla
  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Nombre entidad",
      width: 200,
      dataIndex: "nombre",
      key: "nombre",
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => {
        return datos.length > 24 ? (
          <Popover content={datos} title="Nombre Entidad">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.substring(0, 24)}...`}</span>
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Fecha inicio",
      width: 100,
      dataIndex: "fecha_inicio",
      key: "fecha_inicio",
    },
    {
      title: "Fecha terminación",
      width: 100,
      dataIndex: "fecha_terminacion",
      key: "fecha_terminacion",
    },
    {
      title: "Tiempo total",
      width: 140,
      key: "tiempo_total",
      render: (datos: any) => {
        const { anios, meses } = calcularDiferenciaAniosMeses(datos?.fecha_inicio, datos?.fecha_terminacion);
        const partes: string[] = [];
        if (anios > 0) partes.push(`${anios} año${anios !== 1 ? "s" : ""}`);
        if (meses > 0 || anios === 0) partes.push(`${meses} mes${meses !== 1 ? "es" : ""}`);
        return partes.join(" ");
      },
    },
    {
      title: "Cargo",
      width: 100,
      dataIndex: "cargo",
      key: "cargo",
      render: (datos: any) => {
        return datos.length > 24 ? (
          <Popover content={datos} title="Cargo">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${datos.substring(0, 24)}...`}</span>
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Anexo",
      width: 100,
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Acciones</div>
          <div className="col-4 text-nowrap font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 text-nowrap font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 text-nowrap font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 100,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setExperiencia(datos);
                setIndexExperiencia(index);
                return setModalVisualizar(true);
              }}
              icon={<EyeOutlined />}
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setExperiencia(datos);
                setIndexExperiencia(index);
                return setModaleditar(true);
              }}
              icon={<EditOutlined />}
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                console.log(datos);
                setIndexExperiencia(index);
                setNombreConvocatoria(datos.nombre);
                return setModaleliminar(true);
              }}
              icon={<DeleteOutlined />}
            ></Button>
          </div>
        </div>
      ),
    },
  ];
  // form
  const fields = [
    { name: "nombre", value: experiencia.nombre },
    { name: "fecha_inicio", value: experiencia.fecha_inicio },
    { name: "fecha_terminacion", value: experiencia.fecha_terminacion },
    { name: "cargo", value: experiencia.cargo },
    { name: "funciones", value: experiencia.funciones },
    { name: "documento", value: experiencia.documento },
  ];

  const [visualizarAviso, setVisualizarAviso] = useState<boolean>(true);

  return (
    <>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Mi experiencia profesional" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <div className="row">
          <TextoInicialJurados
            TituloSpan="Agrega tu experiencia profesional."
            TitulosinSpan=""
          />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="row mt-4 g-1 pe-0">
              <div className="col-1 ms-1 me-0 d-flex justify-content-center align-content-center font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion numero-jurados">
                5
              </div>
              <h2 className="col ps-0 ms-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
                Agregar Experiencia profesional
              </h2>
            </div>
          </div>
          <div className="col-12">
            <Form
              size="large"
              name="basic"
              onFinish={(values: any) => {
                if (values.documento === "") {
                  return openNotification({
                    titulo: "Error",
                    descripcion: "Falta adjuntar archivo",
                    placement: "bottomRight",
                  });
                }
                agregarFila();
              }}
              fields={fields}
              onFieldsChange={(changedFields) => handleSimpleFieldsChange(changedFields, experiencia, setExperiencia)}
            >
              <div className="col-12">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-6 col-xxl-6 mt-4">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                      Nombre entidad / Proyecto
                    </span>
                    <div className="row">
                      <div className="col-12">
                        <Form.Item
                          className="no-margin"
                          name="nombre"
                          rules={[
                            { required: true, message: "Campo obligatorio" },
                          ]}
                        >
                          <Input
                            onChange={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^a-zA-Záéíóú ]+/g,
                                ""
                              );
                              setExperiencia({
                                ...experiencia,
                                nombre: e.target.value,
                              });
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-3 col-xxl-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                      Fecha de inicio
                    </span>
                    <Form.Item
                      className="no-margin"
                      name="fecha_inicio"
                      rules={[{ required: true, message: "Campo obligatorio" }]}
                    >
                      <DateInput
                        save={(fecha) => {
                          setExperiencia({
                            ...experiencia,
                            fecha_inicio: fecha,
                          });
                        }}
                        dia={experiencia?.fecha_inicio?.split("-")[2] || ""}
                        mes={experiencia?.fecha_inicio?.split("-")[1] || ""}
                        anio={experiencia?.fecha_inicio?.split("-")[0] || ""}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-12 col-lg-3 col-xxl-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                      Fecha de terminación
                    </span>
                    <Form.Item
                      className="no-margin"
                      name="fecha_terminacion"
                      rules={[{ required: true, message: "Campo obligatorio" }]}
                    >
                      <DateInput
                        save={(fecha) => {
                          setExperiencia({
                            ...experiencia,
                            fecha_terminacion: fecha,
                          });
                        }}
                        dia={experiencia?.fecha_terminacion?.split("-")[2] || ""}
                        mes={experiencia?.fecha_terminacion?.split("-")[1] || ""}
                        anio={experiencia?.fecha_terminacion?.split("-")[0] || ""}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 col-xxl-6 mt-4">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                      Cargo / Rol desempeñado
                    </span>
                    <div className="row">
                      <div className="col-12">
                        <Form.Item
                          className="no-margin"
                          name="cargo"
                          rules={[
                            { required: true, message: "Campo obligatorio" },
                          ]}
                        >
                          <Input
                            onChange={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^a-zA-Záéíóú ]+/g,
                                ""
                              );
                              setExperiencia({
                                ...experiencia,
                                cargo: e.target.value,
                              });
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 col-xxl-6 mt-4">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                      Anexar documento
                    </span>
                    <div className="row">
                      <div className="col-12">
                        <Form.Item
                          className="no-margin"
                          name="documento"
                          rules={[
                            {
                              required: true,
                              message: "Documento obligatorio",
                            },
                          ]}
                        >
                          <DocumentInput
                            doc={experiencia.documento}
                            fileInputRef={fileInputRef}
                            ancho_btn={30}
                            on_change={(e) => {
                              guardarArchivo(e);
                              e.target.value = "";
                            }}
                            onDelete={() => {
                              setExperiencia({
                                ...experiencia,
                                documento: "",
                              });
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 col-xxl-12 mt-4">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                      Funciones principales
                    </span>
                    <div className="row">
                      <div className="col-12">
                        <Form.Item
                          className="no-margin"
                          name="funciones"
                          rules={[
                            { required: true, message: "Campo obligatorio" },
                          ]}
                        >
                          <Input.TextArea showCount maxLength={1000} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="justify-content-flex-end">
                    <span className="width-100"></span>
                    <div className="row">
                      <div
                        className="col"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "end",
                        }}
                      >
                        <Button
                          className="button-azul-ghost font-size-12px"
                          style={{ marginBottom: "20px" }}
                          onClick={limpiarCampos}
                        >
                          Limpiar campos
                        </Button>
                        <Button
                          className="button-blanco-radius font-size-12px"
                          htmlType="submit"
                        >
                          Agregar
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
          <div className="col-12">
            <Table
              dataSource={experiencias}
              columns={columns}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              size="large"
              bordered={false}
              pagination={false}
            />
          </div>
          <div className="col-12 mt-2 mb-3 d-flex justify-content-end">
            <span className="font-family-Montserrat-SemiBold font-size-14px">
              Total acumulado: {`${totalTiempo.anios} año${totalTiempo.anios !== 1 ? "s" : ""} ${totalTiempo.meses} mes${totalTiempo.meses !== 1 ? "es" : ""}`}
            </span>
          </div>
          <div className="col-12 justify-content-flex-end">
            <Button className="button-blanco-radius" style={{ marginRight: "16px" }} onClick={() => {
              guardarExperienciaJuradoProfesional();
              return navigate('/usuario/educacionNoFormal');
            }}>Atrás</Button>
            <Button
              className="button-azul-radius"
              onClick={guardarExperienciaJurado}
            >
              Continuar
            </Button>
          </div>
        </div>
      </div>
      <Footer />
      <ModalEditarExperienciasProfesionales
        experiencia={experiencia}
        setExperiencia={setExperiencia}
        experiencias={experiencias}
        setExperiencias={setExperiencias}
        modal={modaleditar}
        setModal={setModaleditar}
        guardarCambios={guardarCamposModal}
        limpiarcampos={limpiarCampos}
        cancelar={() => setModaleliminar(false)}
      />
      <ModalEliminarExperienciasPorfesionales
        modal={modaleliminar}
        nombre={nombreConvocatoria}
        eliminar={() => eliminarFila(indexExperiencia)}
        cancelar={() => setModaleliminar(false)}
      />
      <ModalVisualizarDocumentos
        state={experiencia}
        visualizar={modalVisualizar}
        setVisualizar={setModalVisualizar}
        tipo="participante"
      />
      <ModalVisualizarAviso
        visualizar={visualizarAviso}
        setVisualizar={setVisualizarAviso}
      />
    </>
  );
};
